export default class Payment{
    constructor(total=0,type='card',naem="",dni="",number='',targetSecurity='',fechExpirationYear="",fechExpirationMount=""){
        this.total=total;
        this.type=type;
        this.number=number;
        this.name=name;
        this.dni=dni;
        this.targetSecurity=targetSecurity;
        this.fechExpirationYear=fechExpirationYear;
        this.fechExpirationMount=fechExpirationMount;
        
    }
}